import { render, staticRenderFns } from "@/components/Layout/Comentarios_detalle/Comentarios_detalle.html?vue&type=template&id=efed14b2&scoped=true&"
import script from "@/components/Layout/Comentarios_detalle/Comentarios_detalle.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Comentarios_detalle/Comentarios_detalle.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Comentarios_detalle/Comentarios_detalle.css?vue&type=style&index=0&id=efed14b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efed14b2",
  null
  
)

export default component.exports